import { useQuery } from '@tanstack/react-query';
import { pagesConfig } from '../../../shared/pages-config';
import LabCard from './lab-card';
import { getAllLabsFeatures, UserKeys } from '../../../api/users-api';
import { Messages } from '../../../utils/message-constants';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const skeletons = Array.from({ length: 6 }, (_, index) => ({
  key: index,
}));

export default function LabsPage() {
  const { activeLabs } = useUserSettings();

  const { data: labs, isLoading: labsLoading } = useQuery({
    queryKey: [UserKeys.FeatureEntities],
    queryFn: () => getAllLabsFeatures(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('labs'),
    },
  });

  const visibleLabs = labs?.filter((lab) => !lab.hidden);

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.administration.name },
        { label: pagesConfig.labs.name },
      ]}
      bookmarkKey={pagesConfig.labs.value}
    >
      <Box>
        <Typography variant="body1">
          gPanel Labs is a testing environment for experimental features that
          may change, break, or be removed at any time.
        </Typography>
        <Stack
          mt={3}
          direction="row"
          gap={2}
          display={'flex'}
          flexWrap={'wrap'}
        >
          {labsLoading ? (
            skeletons.map((skeleton) => (
              <Skeleton
                key={skeleton.key}
                sx={{
                  height: 350,
                  flex: '0 1 calc((100% - 32px) / 3)',
                  minWidth: 300,
                  maxWidth: 450,
                }}
                variant="rounded"
              />
            ))
          ) : visibleLabs && visibleLabs.length > 0 ? (
            visibleLabs.map((lab) => (
              <LabCard
                key={lab.featureString}
                lab={lab}
                featureAccess={activeLabs}
              />
            ))
          ) : (
            <Typography variant="body1">No labs available.</Typography>
          )}
        </Stack>
      </Box>
    </SimpleBreadcrumbsPage>
  );
}
